class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
    const discountInterval = setInterval(() => {
      const payWhirlPrices = document.querySelectorAll(".paywhirl-price");
      if (payWhirlPrices.length > 1) {
        this.updateDiscount();
        // this.updateTotalPrice();
        clearInterval(discountInterval);
      }
    }, 500);
    // const quantityInput = document.querySelector(
    //   ".product-form__quantity .quantity__input"
    // );
    // if (quantityInput) {
    //   quantityInput.addEventListener("change", () => {
    //     this.updateTotalPrice();
    //   });
    // }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
        this.updateBanner();
        this.updateDiscount();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1].quantity;
        const message =
          updatedValue !== parseInt(quantityElement.value)
            ? window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              )
            : "";
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.updateBanner();
        this.updateDiscount();
      });
  }

  updateBanner() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        const barBanner = document.querySelectorAll(
          "#shopify-section-announcement-bar .banner-container"
        );
        this.updateCampaign(barBanner, data);
        const cartBanner = document.querySelectorAll(
          ".cart-drawer .banner-container"
        );
        this.updateCampaign(cartBanner, data);

        const quantityContainers = document.querySelectorAll(
          ".quantity-adder_container"
        );
        if (quantityContainers.length) {
          const quantityAdders = document.querySelectorAll(
            ".quantity-adder_section"
          );
          const quantityAddersArray = Array.from(quantityAdders);
          quantityAddersArray.sort((a, b) => {
            const amountA = parseFloat(a.dataset.amount);
            const amountB = parseFloat(b.dataset.amount);

            return amountB - amountA;
          });
          let found = false;
          quantityAddersArray.forEach((quantityAdder) => {
            const items = quantityAdder.dataset.amount;
            let remaining = items;
            data.items.forEach((item) => {
              if (!item.selling_plan_allocation) {
                remaining = remaining - item.quantity;
              }
            });
            if (remaining < 1 && !found) {
              quantityAdder.classList.add("complete");
              found = true;
            } else {
              quantityAdder.classList.remove("complete");
            }
          });
        }
        this.updateDiscount();
      });
  }

  updateCampaign(container, data) {
    if (container.length) {
      const containerArray = Array.from(container);
      containerArray.sort((a, b) => {
        const amountA = parseFloat(a.dataset.products);
        const amountB = parseFloat(b.dataset.products);
        return amountB - amountA;
      });
      let found = false;
      containerArray.forEach((bannerContainer) => {
        const productCount = bannerContainer.dataset.products;
        let remaining = productCount;
        data.items.forEach((item) => {
          if (item.product_type == bannerContainer.dataset.type) {
            if (!item.selling_plan_allocation) {
              remaining = remaining - item.quantity;
            }
          }
        });
        if (remaining < 0) remaining = 0;
        const amountText = bannerContainer.querySelector(".banner-amount");
        amountText.innerHTML = remaining;
        const productImages =
          bannerContainer.querySelectorAll(".product-image");
        if (productImages.length < 1) return;
        productImages.forEach((image) => {
          image.classList.remove("success");
        });
        bannerContainer.dataset.complete = false;
        if (found) {
          amountText.innerHTML = productCount;
          bannerContainer.classList.add("previously-complete");
        }
        if (remaining < productCount && !found) {
          for (let i = 0; i < productCount - remaining; i++) {
            productImages[i].classList.add("success");
          }
          if (remaining < 1) {
            bannerContainer.dataset.complete = true;
            found = true;
          } else {
            bannerContainer.dataset.complete = false;
          }
        }
      });
    }
  }

  updateDiscount() {
    const campaignSuccess = document.querySelector(
      ".banner-container[data-complete='true']"
    );
    const discount = document.querySelector(".paywhirl-price.discount");
    if (discount) discount.remove();
    if (campaignSuccess) {
      const discount = campaignSuccess.dataset.discount;
      const payWhirl = document.querySelector(".paywhirl-price");
      let dupe = payWhirl.cloneNode(true);
      dupe.classList.add("discount");
      payWhirl.insertAdjacentElement("afterend", dupe);
      let numericPart = payWhirl.innerText.match(/\d+,\d+/);
      if (numericPart) {
        let numericValue = parseFloat(numericPart[0].replace(",", "."));
        var discountAmount = (discount / 100) * numericValue;
        var discountedValue = numericValue - discountAmount;
        dupe.innerText = dupe.innerText.replace(
          numericPart[0],
          discountedValue.toFixed(2).replace(".", ",")
        );
      }
    }
  }

  // updateTotalPrice() {
  //   if (
  //     !document
  //       .getElementById("paywhirl-one-time-purchase-group")
  //       .classList.contains("paywhirl-group-selected")
  //   )
  //     return;
  //   var totalPrice = document.querySelector(".total_price");
  //   if (totalPrice) {
  //     let quantity = document.querySelector(
  //       ".product-form__quantity .quantity__input"
  //     ).value;
  //     let price = document.querySelector(".paywhirl-price").innerText;
  //     let discountPrice = document.querySelector(".paywhirl-price.discount");
  //     if (discountPrice) {
  //       price = discountPrice.innerText;
  //     }
  //     let numericPart = price.match(/\d+,\d+/);
  //     if (numericPart) {
  //       let numericValue = parseFloat(numericPart[0].replace(",", "."));
  //       let total = numericValue * quantity;
  //       totalPrice.innerText =
  //         " - " + total.toFixed(2).replace(".", ",") + " DKK";
  //     }
  //   }
  // }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
